{
    "Hnb2WiC2F": {
        "key": "Hnb2WiC2F",
        "isDead": false,
        "position": {
            "x": 16,
            "y": 23,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "uKSBYZyznL": {
        "key": "uKSBYZyznL",
        "isDead": false,
        "position": {
            "x": 16,
            "y": 24,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "0FiFyFMeT": {
        "key": "0FiFyFMeT",
        "isDead": false,
        "position": {
            "x": 17,
            "y": 24,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "ysR4RFer4": {
        "key": "ysR4RFer4",
        "isDead": false,
        "position": {
            "x": 14,
            "y": 18,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "eSUxlgIgC0": {
        "key": "eSUxlgIgC0",
        "isDead": false,
        "position": {
            "x": 14,
            "y": 17,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "r3Adbj-Pch": {
        "key": "r3Adbj-Pch",
        "isDead": false,
        "position": {
            "x": 15,
            "y": 17,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "5yarueq6Z": {
        "key": "5yarueq6Z",
        "isDead": false,
        "position": {
            "x": 15,
            "y": 18,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "mdmBujtHa": {
        "key": "mdmBujtHa",
        "isDead": false,
        "position": {
            "x": 21,
            "y": 14,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "vhsL9d0wcA": {
        "key": "vhsL9d0wcA",
        "isDead": false,
        "position": {
            "x": 20,
            "y": 13,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "i2X-Gr2DDq": {
        "key": "i2X-Gr2DDq",
        "isDead": false,
        "position": {
            "x": 21,
            "y": 13,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "BQ6nvtHQ6": {
        "key": "BQ6nvtHQ6",
        "isDead": false,
        "position": {
            "x": 20,
            "y": 14,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "5ntpXEeT6": {
        "key": "5ntpXEeT6",
        "isDead": false,
        "position": {
            "x": 13,
            "y": 25,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "pirates/hammer",
        "maxhealth": "30",
        "imageKey": "skeleton",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "MJyrhULmC": {
        "key": "MJyrhULmC",
        "isDead": false,
        "position": {
            "x": 12,
            "y": 23,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "pirates/gun",
        "imageKey": "skeleton",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "FOceUhG0G": {
        "key": "FOceUhG0G",
        "isDead": false,
        "position": {
            "x": 16,
            "y": 20,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "pirates/sword",
        "maxhealth": "30",
        "imageKey": "skeleton",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "65roNm3UT": {
        "key": "65roNm3UT",
        "isDead": false,
        "position": {
            "x": 18,
            "y": 22,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "pirates/sword",
        "maxhealth": "30",
        "imageKey": "skeleton",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "bERjTMiJz": {
        "key": "bERjTMiJz",
        "isDead": false,
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "pirates/hammer",
        "maxhealth": "30",
        "imageKey": "skeleton",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "vPFKbmGA8": {
        "key": "vPFKbmGA8",
        "isDead": false,
        "position": {
            "x": 16,
            "y": 18,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "DC1M_cNhw": {
        "key": "DC1M_cNhw",
        "isDead": false,
        "position": {
            "x": 14,
            "y": 16,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "mpE0lBhuJ": {
        "key": "mpE0lBhuJ",
        "isDead": false,
        "position": {
            "x": 22,
            "y": 14,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "zone"
    },
    "s-GofCsFOonKFtFRO5MfS": {
        "key": "s-GofCsFOonKFtFRO5MfS",
        "isDead": false,
        "position": {
            "x": 20,
            "y": 23,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "pirates/sword",
        "maxhealth": "30",
        "imageKey": "skeleton",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "s74UTAZyTalctz8gx2INm": {
        "key": "s74UTAZyTalctz8gx2INm",
        "isDead": false,
        "position": {
            "x": 17,
            "y": 13,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "pirates/dagger",
        "imageKey": "skeleton",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "YCuGiNUdyb9X2azDVRYR4": {
        "key": "YCuGiNUdyb9X2azDVRYR4",
        "isDead": false,
        "position": {
            "x": 15,
            "y": 13,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "pirates/gun",
        "imageKey": "skeleton",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "2qFc4RXxuXy_eYXG5kbcd": {
        "key": "2qFc4RXxuXy_eYXG5kbcd",
        "isDead": false,
        "position": {
            "x": 18,
            "y": 15,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "pirates/sword",
        "maxhealth": "30",
        "imageKey": "skeleton",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "treasureA": {
        "key": "treasureA",
        "isDead": false,
        "position": {
            "x": 22,
            "y": 11,
            "z": 1
        },
        "affiliation": "nothing",
        "energy": {},
        "jobKey": "pirates/chest",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "treasureB": {
        "key": "treasureB",
        "isDead": false,
        "position": {
            "x": 20,
            "y": 12,
            "z": 1
        },
        "affiliation": "nothing",
        "energy": {},
        "jobKey": "pirates/chest",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "treasureC": {
        "key": "treasureC",
        "isDead": false,
        "position": {
            "x": 24,
            "y": 13,
            "z": 1
        },
        "affiliation": "nothing",
        "energy": {},
        "jobKey": "pirates/chest",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "4Ge5o_5sM88HESgwfSndg": {
        "key": "4Ge5o_5sM88HESgwfSndg",
        "isDead": false,
        "position": {
            "x": 14,
            "y": 23,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "pirates/gun",
        "imageKey": "skeleton",
        "effects": {},
        "inventory": {
            "items": {}
        }
    }
}